import React, { useState } from 'react';
import { getBarColor } from '../modals/HealthAdjustModal';
import { Box, Button } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { WarbandMemberDTO } from '../../types';
import { getSplitStatValue } from '../../utils/splitStats';
import { useWarbandStore } from '../../stores/warbandStore';
import { HealthAdjustModal } from '../modals/HealthAdjustModal';

interface CurrentHealthUpdateControlsProps {
  member: WarbandMemberDTO;
  saving?: boolean;
  healthBonus?: number;
  onSave: (nextHealth: number) => Promise<void> | void;
}

export const CurrentHealthUpdateControls: React.FC<CurrentHealthUpdateControlsProps> = ({
  member,
  saving = false,
  healthBonus = 0,
  onSave,
}) => {
  const [open, setOpen] = useState(false);
  const warbandBuffs = useWarbandStore((s) => s.warbandBuffs);
  const maxHealth = getSplitStatValue(member, 'health', member.health + healthBonus, warbandBuffs);

  const effectiveCurrentHealth = Math.min(member.currentHealth, maxHealth);

  const handleApply = async (nextHealth: number) => {
    await onSave(nextHealth);
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        size="small"
        startIcon={<FavoriteIcon sx={{ color: getBarColor(effectiveCurrentHealth, maxHealth) }} />}
        onClick={() => setOpen(true)}
        disabled={saving}
        sx={{ minWidth: '100%' }}
      >
        {effectiveCurrentHealth}
      </Button>
      <HealthAdjustModal
        open={open}
        currentHealth={effectiveCurrentHealth}
        maxHealth={maxHealth}
        onClose={() => setOpen(false)}
        onApply={handleApply}
      />
    </>
  );
};